module.exports = __webpack_public_path__ + "img/view_third.3edc46a2.png";